import { render, staticRenderFns } from "./Vars.vue?vue&type=template&id=0530a284&scoped=true"
import script from "./Vars.vue?vue&type=script&lang=js"
export * from "./Vars.vue?vue&type=script&lang=js"
import style0 from "./Vars.vue?vue&type=style&index=0&id=0530a284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530a284",
  null
  
)

export default component.exports